import { render, staticRenderFns } from "./MypageDepositList.vue?vue&type=template&id=50db9b6c&scoped=true&"
import script from "./MypageDepositList.vue?vue&type=script&lang=js&"
export * from "./MypageDepositList.vue?vue&type=script&lang=js&"
import style0 from "./MypageDepositList.vue?vue&type=style&index=0&id=50db9b6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50db9b6c",
  null
  
)

export default component.exports